import React, { Component }  from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    return ( 
        <nav className="navbar navbar-expand-md navbar-light fixed-top bg-main">
            <div className="container">
                <Link to="/" className="navbar-brand">Summarecon Apps</Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarText">
                <ul className="navbar-nav ms-auto">
                    <li className="nav-item">
                        <Link to="/#" className="nav-link">Tentang Kami</Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/#benefit" className="nav-link">Keuntungan Apps</Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/#mall" className="nav-link">FAQ</Link>  
                    </li>
                    <li className="nav-item">
                        <Link to="/#hubungi_kami" className="nav-link">Hubungi Kami</Link>  
                    </li>
                </ul>
                </div>
            </div>
        </nav>
    );
}
 
export default Header;